import { render, staticRenderFns } from "./projectNotes.vue?vue&type=template&id=74634793&scoped=true&"
import script from "./projectNotes.vue?vue&type=script&lang=js&"
export * from "./projectNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74634793",
  null
  
)

export default component.exports